import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "@ts-digital/vrc";
import {
  openEinvoicePreview,
  openPreviewNew
} from "../../../store/actions/detailsDocument/preview";
import { downloadDocument } from "../../../store/actions/download/index";

import EInvoicePreview from "../../preview/eInvoice";
import HeaderPreview from "./header";
import ModalZoom from "../../preview/modalZoom";
import NonePreview from "./nonePreview";
import NoPreview from "../noPreview";

import "./style.css";
import { useIntl } from "react-intl";

const Preview = props => {
  const {
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected,
    documentId,
    fileName,
    isEinvoice,
    myType,
    previewIndex
  } = props;
  const dispatch = useDispatch();
  const [einvoiceType, setEinvoiceType] = useState("ASSOSW");
  const [isFirstPage, setIsFirstPage] = useState(true);
  const [isPreviewModal, setIsPreviewModal] = useState(false);
  const [previewContent, setPreviewContent] = useState(null);
  const intl = useIntl();

  // BEGIN REDUX STATE

  const info = useSelector(state => state.detailsDocument.info);
  const previewDetails = useSelector(state => state.detailsDocument.previewDetails);
  const subjective = useSelector(state => state.deadlinesDetail.subjective);
  const attachmentDetails = useSelector(state =>
    subjective !== null
      ? state.deadlinesDetail.subjective.attachmentsDetail
      : null);

  // END REDUX STATE

  useEffect(() => {
    // if (previewContent) return null;
    isEinvoice
      ? dispatch(openEinvoicePreview(documentId ? documentId : info.details.documentId,
        einvoiceType))
      : dispatch(openPreviewNew(
        documentId ? documentId : info.details.documentId,
        1,
        false
      ));
  }, [documentId, einvoiceType]);

  useEffect(() => {
    // Elimino margini Modale non sovrapponibile lo style per problemi di className random
    let nearestElem = document.getElementsByClassName("modalContent");
    if (nearestElem && nearestElem.length > 0) {
      nearestElem[0].parentNode.style.maxHeight = "calc(100vh - 140px)";
      nearestElem[0].parentNode.parentNode.style.marginTop = "70px";
    }
    const selectedAttachment =
      attachmentDetails !== null && attachmentDetails !== undefined
        ? attachmentDetails[previewIndex]
        : null;

    const preview =
      isFirstPage && previewDetails.content
        ? previewDetails.content
        : selectedAttachment !== undefined && selectedAttachment !== null
          ? selectedAttachment.content
          : previewContent;
    setPreviewContent(preview);
  }, [previewDetails.content, previewIndex]);

  const details =
    info.detail &&
    info.details.infoList.filter(el => el.label === "Data documento");
  const title =
    details && details.length > 0
      ? "Anteprima fattura del " + details[0].value
      : "Anteprima fattura";

  const openPreviewPage = async pageIndex => {
    dispatch(openPreviewNew(
      documentId ? documentId : info.details.documentId,
      pageIndex,
      info.details.einvoice
    ));
    setIsFirstPage(false);
  };

  const renderZoomOverlay = () => {
    return (
      <div
        className="overlay gs-documents-detail-preview"
        onClick={e => {
          document.body.className = document.body.className + " overflowHidden";
          document.getElementsByTagName("body")[0].style.overflow = "hidden";
          setIsPreviewModal(true);
        }}
      >
        <FontAwesomeIcon
          className="iconZoom"
          icon={["fas", "search"]}
          style={{ fontSize: "64px", color: "#fff" }}
        />
      </div>
    );
  };

  return (
    <div>
      <HeaderPreview
        documentId={documentId}
        einvoiceType={einvoiceType}
        fileName={fileName}
        isEinvoice={isEinvoice}
        previewContent={previewContent}
        setEinvoiceType={setEinvoiceType}
      />
      <div
        className={"previewImgContainer" + (previewContent ? "" : " noZoom")}
        style={{ height: "100%" }}
      >
        {previewDetails.status.started && !isPreviewModal && (
          <div style={{ textAlign: "center", marginTop: "calc(50vh - 120px)" }}>
            <FontAwesomeIcon
              icon={["far", "circle-notch"]}
              spin
              style={{ color: "#0090d1", fontSize: "42px" }}
            />
          </div>
        )}

        {previewDetails.status.ended && !previewContent && (
          <NonePreview previewContent={previewContent} />
        )}

        {previewDetails.status.ended && previewContent && isEinvoice && (
          <div>
            {renderZoomOverlay()}
            <EInvoicePreview
              accountantSelected={accountantSelected}
              accountantIdSelected={accountantIdSelected}
              companySelected={companySelected}
              clientIdSelected={clientIdSelected}
              documentId={documentId}
              einvoiceType={einvoiceType}
              fileName={fileName}
              isEinvoice={isEinvoice}
              isDownloadVisible={true}
              isInModal={false}
              myType={myType}
              previewContent={previewContent}
              setEinvoiceType={setEinvoiceType}
            />
            <div className="modalPreview">
              <Modal
                visible={isPreviewModal}
                title={title}
                onClose={e => {
                  document.getElementsByTagName("body")[0].style.overflow =
                    "auto";
                  setIsPreviewModal(false);
                }}
                type="primary"
                outsideClosable={false}
              >
                <div className="modalContent">
                  <EInvoicePreview
                    accountantSelected={accountantSelected}
                    accountantIdSelected={accountantIdSelected}
                    companySelected={companySelected}
                    clientIdSelected={clientIdSelected}
                    documentId={documentId}
                    einvoiceType={einvoiceType}
                    fileName={fileName}
                    isEinvoice={isEinvoice}
                    isInModal={isPreviewModal}
                    isDownloadVisible={true}
                    myType={myType}
                    previewContent={previewContent}
                    setEinvoiceType={setEinvoiceType}
                  />
                </div>
              </Modal>
            </div>
          </div>
        )}

        {!isEinvoice && (
          <>
            {previewDetails.status.ended && previewContent && (
              <img
                className="documentPreview"
                src={"data:image/jpeg;base64," + previewContent}
                alt="Preview documento"
                style={{ width: "100%", cursor: "pointer" }}
              />
            )}
            <div>
              {renderZoomOverlay()}
              <div className="modalPreview">
                <Modal
                  visible={isPreviewModal}
                  title={intl.formatMessage({id: "documents.preview.previewDoc", defaultMessage: "Anteprima documento"})}
                  onClose={e => {
                    document.getElementsByTagName("body")[0].style.overflow =
                      "auto";
                    setIsPreviewModal(false);
                  }}
                  type="primary"
                  outsideClosable={false}
                >
                  {!previewContent && previewDetails.status.ended ? (
                    <NoPreview height={"calc(100vh - 350px)"} />
                  ) : (
                    <ModalZoom
                      downloadState={null}
                      downloadDocument={() => {
                        dispatch(downloadDocument(
                          documentId
                            ? documentId
                            : info.details
                              ? info.details.documentId
                              : null,
                          fileName ? fileName : info.details.fileName,
                          isEinvoice
                            ? isEinvoice
                            : info.details
                              ? info.details.einvoice
                              : false,
                          null
                        ));
                      }}
                      previewContent={previewContent}
                      imgSrc={
                        previewDetails.content
                          ? "data:image/jpeg;base64," + previewDetails.content
                          : null
                      }
                      isVisible={isPreviewModal}
                      onClose={e => setIsPreviewModal(false)}
                      openPreviewPage={openPreviewPage}
                      pagesTotal={
                        info.details && info.details.numberOfPages
                          ? info.details.numberOfPages
                          : 1
                      }
                    />
                  )}
                </Modal>
              </div>
            </div>
          </>
        )}
        {isEinvoice && !previewDetails.content && (
          <>
            {previewContent && (
              <img
                className="documentPreview"
                src={"data:image/jpeg;base64," + previewContent}
                alt="Preview documento"
                style={{ width: "100%", cursor: "pointer" }}
              />
            )}
            <div>
              {renderZoomOverlay()}
              <div className="modalPreview">
                <Modal
                  visible={isPreviewModal}
                  title={intl.formatMessage({id: "documents.preview.previewDoc", defaultMessage: "Anteprima documento"})}
                  onClose={e => {
                    document.getElementsByTagName("body")[0].style.overflow =
                      "auto";
                    setIsPreviewModal(false);
                  }}
                  type="primary"
                  outsideClosable={false}
                >
                  {!previewContent && previewDetails.status.ended ? (
                    <NoPreview height={"calc(100vh - 350px)"} />
                  ) : (
                    <ModalZoom
                      downloadState={null}
                      downloadDocument={() => {
                        dispatch(downloadDocument(
                          documentId
                            ? documentId
                            : info.details
                              ? info.details.documentId
                              : null,
                          fileName ? fileName : info.details.fileName,
                          isEinvoice
                            ? isEinvoice
                            : info.details
                              ? info.details.einvoice
                              : false,
                          null
                        ));
                      }}
                      previewContent={previewContent}
                      imgSrc={
                        previewDetails.content
                          ? "data:image/jpeg;base64," + previewDetails.content
                          : null
                      }
                      isVisible={isPreviewModal}
                      onClose={e => setIsPreviewModal(false)}
                      openPreviewPage={openPreviewPage}
                      pagesTotal={
                        info.details && info.details.numberOfPages
                          ? info.details.numberOfPages
                          : 1
                      }
                    />
                  )}
                </Modal>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Preview;
